


































import useCancelButton from "@/composables/buttons/useCancelButton";
import useAssociateButton from "@/composables/buttons/useAssociateButton";
import IButton from "@/interfaces/IButton";
import { computed, defineComponent, ref } from "@vue/composition-api";
import InputGroup from "./InputGroup.vue";
import Popover, { PopoverProps } from "./Popover.vue";
import useEscapeHtml from "@/utilities/useEscapeHtml";

export default defineComponent({
  components: {
    Popover,
    InputGroup,
  },
  props: {
    ...PopoverProps,
  },
  setup(_, { root, emit }) {
    const show = ref(false);
    const entityName = ref("");
    const vatAssociate = ref("");
    var primaryClick: (() => void) | null = null;
    var secondaryClick: (() => void) | null = null;

    function confirmAssociate(
      organizationName: string,
      vat: string,
      confirmationName: string | null
    ): Promise<boolean> {
      show.value = true;
      entityName.value = organizationName;
      vatAssociate.value = vat;

      return new Promise(function (resolve, _) {
        primaryClick = () => {
          resolve(true);
          show.value = false;
        };

        secondaryClick = () => {
          resolve(false);
          show.value = false;
        };
      });
    }

    return {
      useEscapeHtml,
      entityName,
      vatAssociate,
      confirmAssociate,
      show,
      primaryButton: computed<IButton>(() => {
        return {
          ...useAssociateButton(async () => {
            if (primaryClick != null) {
              primaryClick();
            }
          }),
        };
      }),
      secondaryButton: useCancelButton(() => {
        if (secondaryClick != null) {
          secondaryClick();
        }
      }),
    };
  },
});
